import React, { useState, useRef } from "react";
import { themeStyle } from "../components/Components";
import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import {
  API_URL,
  DOMAIN_URL,
  APPBAR,
  MAIN_TITLE,
  LOGOGOLDEN,
  ADDRESS,
  SUBADMISSION,
} from "../actions/auth";
import ErrorIcon from "@mui/icons-material/Error";
import Snackbar from "@mui/material/Snackbar";
import Card from "@mui/material/Card";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import AddIcon from "@mui/icons-material/Add";
import CheckIcon from "@mui/icons-material/Check";
import ButtonBase from "@mui/material/ButtonBase";
import PublishIcon from "@mui/icons-material/Publish";
import Modal from "@mui/material/Modal";
import Backdrop from "@mui/material/Backdrop";
import Fade from "@mui/material/Fade";
import CircularProgress from "@mui/material/CircularProgress";
import {
  TextField,
  Checkbox,
  FormControlLabel,
  Button,
  MenuItem,
  Typography,
  Box,
  Grid,
} from "@mui/material";
import axios from "axios";
import moment from "moment";
import { sha512 } from "js-sha512";
import html2pdf from "html3pdf";

function makeid(length) {
  var result = "";
  var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

const StudentRegistrationForm = () => {
  const state = useSelector((state) => state);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch({
      type: "NAV_COLOR",
      payload: { navColor: "#000c66", navOpacity: 1 },
    });
  }, []);

  const boltScriptRef = useRef(null);

  const [selectedFileBirth, setSelectedFileBirth] = useState("");
  const [selectedFileLeaving, setSelectedFileLeaving] = useState("");
  const [selectedFileProgress, setSelectedFileProgress] = useState("");
  const [selectedFileAadhar, setSelectedFileAadhar] = useState("");
  const [selectedFilePhoto, setSelectedFilePhoto] = useState("");
  const [selectedFileParent1, setSelectedFileParent1] = useState("");
  const [selectedFileParent2, setSelectedFileParent2] = useState("");
  const [selectedFileBaptism, setSelectedFileBaptism] = useState("");
  const [selectedFileChurch, setSelectedFileChurch] = useState("");
  const [isLoadingDownload, setIsLoadingDownload] = useState(false);

  const [isSubmitting, setIsSubmitting] = useState(false);

  const [openBirth, setOpenBirth] = useState(false);
  const [openAadhar, setOpenAadhar] = useState(false);
  const [openProgress, setOpenProgress] = useState(false);
  const [openLeaving, setOpenLeaving] = useState(false);
  const [openPhoto, setOpenPhoto] = useState(false);
  const [openParent1, setOpenParent1] = useState(false);
  const [openParent2, setOpenParent2] = useState(false);
  const [openBaptism, setOpenBaptism] = useState(false);
  const [openChurch, setOpenChurch] = useState(false);

  const [birth, setBirth] = useState(false);
  const [leaving, setLeaving] = useState(false);
  const [progress, setProgress] = useState(false);
  const [aadhar, setAadhar] = useState(false);
  const [photo, setPhoto] = useState(false);
  const [parent1, setParent1] = useState(false);
  const [parent2, setParent2] = useState(false);
  const [baptism, setBaptism] = useState(false);
  const [church, setChurch] = useState(false);
  const [base64IMG, setBase64IMG] = useState("");
  const [classs, setClass] = useState("");
  const [division, setDivision] = useState("");
  const [classList, setClassList] = useState([]);

  const [formId, setFormId] = useState("");
  const [formIdNew, setFormIdNew] = useState("");

  const [isLoading, setIsLoading] = useState(true);
  const [formSuccess, setFormSuccess] = useState(false);

  function getData() {
    var body = {};
    const config = {
      headers: {
        Authorization: state.auth.token,
        "Content-Type": "application/json",
      },
    };
    body["institution_id"] = "CHSHRXYC";

    body = JSON.stringify(body);
    axios.post(API_URL + "/get_class_list", body, config).then((res) => {
      var classListTemp = res.data;
      setClassList(classListTemp);
      setClass(Object.keys(classListTemp)[0]);
      setDivision(Object.keys(classListTemp[Object.keys(classListTemp)[0]])[0]);
      axios.post(API_URL + "/get_form_count", body, config).then((res) => {
        let currentDate = new Date(); // Creates a new Date object representing the current date and time
        let currentYear = currentDate.getFullYear();
        var formTemp = "CHS-ON-" + (currentYear + 1).toString() + "-";
        if (res.data.toString().length == 1) {
          setFormId(formTemp + "00" + res.data);
        } else if (res.data.toString().length == 2) {
          setFormId(formTemp + "0" + res.data);
        } else {
          setFormId(formTemp + res.data);
        }
        setIsLoading(false);
      });
    });
  }

  const convertToBase64 = (image) => {
    const reader = new FileReader();
    reader.readAsDataURL(image ?? selectedFilePhoto);
    reader.onload = () => {
      setBase64IMG(reader.result);
    };
  };

  useEffect(() => {
    getData();
  }, []);

  function handleClassChange(a, b, e) {
    console.log(a, b, e);
    setClass(e.target.value);
    setFormData({
      ...formData,
      [a]: {
        ...formData[a],
        [b]: e.target.value,
      },
    });
  }

  function handleDivisionChange(a, b, e) {
    console.log(a, b, e);

    setDivision(e.target.value);
    setFormData({
      ...formData,
      [a]: {
        ...formData[a],
        [b]: e.target.value,
      },
    });
  }

  function getDivisionList() {
    var classes = Object.keys(classList[classs]).map((division, index) => (
      <MenuItem value={division}>{division}</MenuItem>
    ));
    return classes;
  }

  const calculateHash = (data) => {
    var result = sha512(data);
    return result;
  };

  const key = "5nY8Jt";
  const txnid = "REG" + moment().format("DDMMYYYY") + makeid(5);

  function fileDataPhoto() {
    if (selectedFilePhoto) {
      return (
        <div style={{ borderRadius: "10px" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <h2>File Details:</h2>
            <IconButton size="small">
              <CloseIcon
                onClick={() => setOpenPhoto(false)}
                style={{ color: themeStyle.primaryColor }}
              />
            </IconButton>
          </div>

          <p>File Name: {selectedFilePhoto.name}</p>
          <p>File Type: {selectedFilePhoto.type}</p>

          <br></br>
          <br></br>
          {selectedFilePhoto.size > 25 * 1024 * 1024 ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                onClick={() => {
                  setSnack2({
                    type: "ERROR",
                    title: "Error!",
                    message: "File size should be less than 25 MB.",
                  });
                  setShowSnack2(true);
                  setOpenBirth(false);
                }}
                variant="contained"
                style={{ backgroundColor: "#ddd" }}
              >
                <PublishIcon />
                &nbsp;&nbsp; UPLOAD PHOTO
              </Button>
            </div>
          ) : selectedFilePhoto.name.length >= 50 ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                onClick={() => {
                  setSnack2({
                    type: "ERROR",
                    title: "Error!",
                    message: "File name too big.",
                  });
                  setShowSnack2(true);
                  setOpenBirth(false);
                }}
                variant="contained"
                style={{ backgroundColor: "#ddd" }}
              >
                <PublishIcon />
                &nbsp;&nbsp; UPLOAD PHOTO
              </Button>
            </div>
          ) : (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                variant="contained"
                onClick={() => onFileUploadPhoto()}
                style={{ backgroundColor: themeStyle.primaryColor }}
              >
                <PublishIcon />
                &nbsp;&nbsp; UPLOAD PHOTO
              </Button>
            </div>
          )}
        </div>
      );
    } else {
      return (
        <div>
          <h4>Choose before Pressing the Upload button</h4>
        </div>
      );
    }
  }

  function onFileUploadPhoto() {
    setIsSubmitting(true);
    const formData = new FormData();
    formData.append("file", selectedFilePhoto, selectedFilePhoto.name);
    formData.append("form_id", formId);

    const config = {
      headers: {
        Authorization: state.auth.token,
      },
    };

    axios
      .post(API_URL + "/upload_photo", formData, config)
      .then(() => {
        setIsSubmitting(false);
        setPhoto(true);
      })
      .catch((err) => {
        setSnack2({
          type: "ERROR",
          title: "Error!",
          message: "An error occured.",
        });
        setShowSnack2(true);
        convertToBase64();
      });

    setOpenPhoto(false);
    document.getElementById("contained-button-file-photo").value = "";
  }

  function onFileChangePhoto(event) {
    setSelectedFilePhoto(event.target.files[0]);
    convertToBase64(event.target.files[0]);
    setOpenPhoto(true);
  }

  function fileDataBirth() {
    if (selectedFileBirth) {
      return (
        <div style={{ borderRadius: "10px" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <h2>File Details:</h2>
            <IconButton size="small">
              <CloseIcon
                onClick={() => setOpenBirth(false)}
                style={{ color: themeStyle.primaryColor }}
              />
            </IconButton>
          </div>

          <p>File Name: {selectedFileBirth.name}</p>
          <p>File Type: {selectedFileBirth.type}</p>

          <br></br>
          <br></br>
          {selectedFileBirth.size > 25 * 1024 * 1024 ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                onClick={() => {
                  setSnack2({
                    type: "ERROR",
                    title: "Error!",
                    message: "File size should be less than 25 MB.",
                  });
                  setShowSnack2(true);
                  setOpenBirth(false);
                }}
                variant="contained"
                style={{ backgroundColor: "#ddd" }}
              >
                <PublishIcon />
                &nbsp;&nbsp; UPLOAD BIRTH CERTIFICATE
              </Button>
            </div>
          ) : selectedFileBirth.name.length >= 50 ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                onClick={() => {
                  setSnack2({
                    type: "ERROR",
                    title: "Error!",
                    message: "File name too big.",
                  });
                  setShowSnack2(true);
                  setOpenBirth(false);
                }}
                variant="contained"
                style={{ backgroundColor: "#ddd" }}
              >
                <PublishIcon />
                &nbsp;&nbsp; UPLOAD BIRTH CERTIFICATE
              </Button>
            </div>
          ) : (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                variant="contained"
                onClick={() => onFileUploadBirth()}
                style={{ backgroundColor: themeStyle.primaryColor }}
              >
                <PublishIcon />
                &nbsp;&nbsp; UPLOAD BIRTH CERTIFICATE
              </Button>
            </div>
          )}
        </div>
      );
    } else {
      return (
        <div>
          <h4>Choose before Pressing the Upload button</h4>
        </div>
      );
    }
  }

  function onFileUploadBirth() {
    setIsSubmitting(true);
    const formData = new FormData();
    formData.append("file", selectedFileBirth, selectedFileBirth.name);
    formData.append("form_id", formId);
    formData.append("institution_id", "CHSHRXYC");
    const config = {
      headers: {
        Authorization: state.auth.token,
      },
    };

    axios
      .post(API_URL + "/upload_birth_certificate", formData, config)
      .then(() => {
        setIsSubmitting(false);
        setBirth(true);
      })
      .catch((err) => {
        setSnack2({
          type: "ERROR",
          title: "Error!",
          message: "An error occured.",
        });
        setShowSnack2(true);
      });

    setOpenBirth(false);
    document.getElementById("contained-button-file-birth").value = "";
  }

  function onFileChangeBirth(event) {
    setSelectedFileBirth(event.target.files[0]);
    setOpenBirth(true);
  }

  function fileDataLeaving() {
    if (selectedFileLeaving) {
      return (
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <h2>File Details:</h2>
            <IconButton size="small">
              <CloseIcon
                onClick={() => setOpenLeaving(false)}
                style={{ color: themeStyle.primaryColor }}
              />
            </IconButton>
          </div>

          <p>File Name: {selectedFileLeaving.name}</p>
          <p>File Type: {selectedFileLeaving.type}</p>

          <br></br>
          <br></br>
          {selectedFileLeaving.size > 25 * 1024 * 1024 ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                onClick={() => {
                  setSnack2({
                    type: "ERROR",
                    title: "Error!",
                    message: "File size should be less than 25 MB.",
                  });
                  setShowSnack2(true);
                  setOpenLeaving(false);
                }}
                variant="contained"
                style={{ backgroundColor: "#ddd" }}
              >
                <PublishIcon />
                &nbsp;&nbsp; UPLOAD LEAVING CERTIFICATE
              </Button>
            </div>
          ) : selectedFileLeaving.name.length >= 50 ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                onClick={() => {
                  setSnack2({
                    type: "ERROR",
                    title: "Error!",
                    message: "File name too big.",
                  });
                  setShowSnack2(true);
                  setOpenLeaving(false);
                }}
                variant="contained"
                style={{ backgroundColor: "#ddd" }}
              >
                <PublishIcon />
                &nbsp;&nbsp; UPLOAD LEAVING CERTIFICATE
              </Button>
            </div>
          ) : (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                variant="contained"
                onClick={() => onFileUploadLeaving()}
                style={{ backgroundColor: themeStyle.primaryColor }}
              >
                <PublishIcon />
                &nbsp;&nbsp; UPLOAD LEAVING CERTIFICATE
              </Button>
            </div>
          )}
        </div>
      );
    } else {
      return (
        <div>
          <h4>Choose before Pressing the Upload button</h4>
        </div>
      );
    }
  }

  function onFileUploadLeaving() {
    setIsSubmitting(true);
    const formData = new FormData();
    formData.append("file", selectedFileLeaving, selectedFileLeaving.name);
    formData.append("form_id", formId);
    formData.append("institution_id", "CHSHRXYC");

    const config = {
      headers: {
        Authorization: state.auth.token,
      },
    };

    axios
      .post(API_URL + "/upload_leaving_certificate", formData, config)
      .then(() => {
        setIsSubmitting(false);
        setLeaving(true);
      })
      .catch((err) => {
        console.log("___");
        console.log(err);
        setSnack2({
          type: "ERROR",
          title: "Error!",
          message: "An error occured.",
        });
        setShowSnack2(true);
      });

    setOpenLeaving(false);
    document.getElementById("contained-button-file-leaving").value = "";
  }

  function onFileChangeLeaving(event) {
    setSelectedFileLeaving(event.target.files[0]);
    setOpenLeaving(true);
  }

  function fileDataProgress() {
    if (selectedFileProgress) {
      return (
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <h2>File Details:</h2>
            <IconButton size="small">
              <CloseIcon
                onClick={() => setOpenProgress(false)}
                style={{ color: themeStyle.primaryColor }}
              />
            </IconButton>
          </div>

          <p>File Name: {selectedFileProgress.name}</p>
          <p>File Type: {selectedFileProgress.type}</p>

          <br></br>
          <br></br>
          {selectedFileProgress.size > 25 * 1024 * 1024 ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                onClick={() => {
                  setSnack2({
                    type: "ERROR",
                    title: "Error!",
                    message: "File size should be less than 25 MB.",
                  });
                  setShowSnack2(true);
                  setOpenProgress(false);
                }}
                variant="contained"
                style={{ backgroundColor: "#ddd" }}
              >
                <PublishIcon />
                &nbsp;&nbsp; UPLOAD PROGRESS REPORT
              </Button>
            </div>
          ) : selectedFileProgress.name.length >= 50 ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                onClick={() => {
                  setSnack2({
                    type: "ERROR",
                    title: "Error!",
                    message: "File name too big.",
                  });
                  setShowSnack2(true);
                  setOpenProgress(false);
                }}
                variant="contained"
                style={{ backgroundColor: "#ddd" }}
              >
                <PublishIcon />
                &nbsp;&nbsp; UPLOAD PROGRESS REPORT
              </Button>
            </div>
          ) : (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                variant="contained"
                onClick={() => onFileUploadProgress()}
                style={{ backgroundColor: themeStyle.primaryColor }}
              >
                <PublishIcon />
                &nbsp;&nbsp; UPLOAD PROGRESS REPORT
              </Button>
            </div>
          )}
        </div>
      );
    } else {
      return (
        <div>
          <h4>Choose before Pressing the Upload button</h4>
        </div>
      );
    }
  }

  function onFileUploadProgress() {
    setIsSubmitting(true);
    const formData = new FormData();
    formData.append("file", selectedFileProgress, selectedFileProgress.name);
    formData.append("form_id", formId);
    formData.append("institution_id", "CHSHRXYC");

    const config = {
      headers: {
        Authorization: state.auth.token,
      },
    };

    axios
      .post(API_URL + "/upload_progress_report", formData, config)
      .then(() => {
        setIsSubmitting(false);
        setProgress(true);
      })
      .catch((err) => {
        console.log("___");
        console.log(err);
        setSnack2({
          type: "ERROR",
          title: "Error!",
          message: "An error occured.",
        });
        setShowSnack2(true);
      });

    setOpenProgress(false);
    document.getElementById("contained-button-file-progress").value = "";
  }

  function onFileChangeProgress(event) {
    setSelectedFileProgress(event.target.files[0]);
    setOpenProgress(true);
  }

  function fileDataAadhar() {
    if (selectedFileAadhar) {
      return (
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <h2>File Details:</h2>
            <IconButton size="small">
              <CloseIcon
                onClick={() => setOpenAadhar(false)}
                style={{ color: themeStyle.primaryColor }}
              />
            </IconButton>
          </div>

          <p>File Name: {selectedFileAadhar.name}</p>
          <p>File Type: {selectedFileAadhar.type}</p>

          <br></br>
          <br></br>
          {selectedFileAadhar.size > 25 * 1024 * 1024 ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                onClick={() => {
                  setSnack2({
                    type: "ERROR",
                    title: "Error!",
                    message: "File size should be less than 25 MB.",
                  });
                  setShowSnack2(true);
                  setOpenAadhar(false);
                }}
                variant="contained"
                style={{ backgroundColor: "#ddd" }}
              >
                <PublishIcon />
                &nbsp;&nbsp; UPLOAD AADHAR CARD
              </Button>
            </div>
          ) : selectedFileAadhar.name.length >= 50 ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                onClick={() => {
                  setSnack2({
                    type: "ERROR",
                    title: "Error!",
                    message: "File name too big.",
                  });
                  setShowSnack2(true);
                  setOpenAadhar(false);
                }}
                variant="contained"
                style={{ backgroundColor: "#ddd" }}
              >
                <PublishIcon />
                &nbsp;&nbsp; UPLOAD AADHAR CARD
              </Button>
            </div>
          ) : (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                variant="contained"
                onClick={() => onFileUploadAadhar()}
                style={{ backgroundColor: themeStyle.primaryColor }}
              >
                <PublishIcon />
                &nbsp;&nbsp; UPLOAD AADHAR CARD
              </Button>
            </div>
          )}
        </div>
      );
    } else {
      return (
        <div>
          <h4>Choose before Pressing the Upload button</h4>
        </div>
      );
    }
  }

  function onFileUploadAadhar() {
    setIsSubmitting(true);
    const formData = new FormData();
    formData.append("file", selectedFileAadhar, selectedFileAadhar.name);
    formData.append("form_id", formId);
    formData.append("institution_id", "CHSHRXYC");

    const config = {
      headers: {
        Authorization: state.auth.token,
      },
    };

    axios
      .post(API_URL + "/upload_aadhar_card", formData, config)
      .then(() => {
        setIsSubmitting(false);
        setAadhar(true);
      })
      .catch((err) => {
        console.log("___");
        console.log(err);
        setSnack2({
          type: "ERROR",
          title: "Error!",
          message: "An error occured.",
        });
        setShowSnack2(true);
      });

    setOpenAadhar(false);
    document.getElementById("contained-button-file-aadhar").value = "";
  }

  function onFileChangeAadhar(event) {
    setSelectedFileAadhar(event.target.files[0]);
    setOpenAadhar(true);
  }

  function fileDataParent1() {
    if (selectedFileParent1) {
      return (
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <h2>File Details:</h2>
            <IconButton size="small">
              <CloseIcon
                onClick={() => setOpenParent1(false)}
                style={{ color: themeStyle.primaryColor }}
              />
            </IconButton>
          </div>

          <p>File Name: {selectedFileParent1.name}</p>
          <p>File Type: {selectedFileParent1.type}</p>

          <br></br>
          <br></br>
          {selectedFileParent1.size > 25 * 1024 * 1024 ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                onClick={() => {
                  setSnack2({
                    type: "ERROR",
                    title: "Error!",
                    message: "File size should be less than 25 MB.",
                  });
                  setShowSnack2(true);
                  setOpenParent1(false);
                }}
                variant="contained"
                style={{ backgroundColor: "#ddd" }}
              >
                <PublishIcon />
                &nbsp;&nbsp; UPLOAD PARENT 1 DEGREE
              </Button>
            </div>
          ) : selectedFileParent1.name.length >= 50 ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                onClick={() => {
                  setSnack2({
                    type: "ERROR",
                    title: "Error!",
                    message: "File name too big.",
                  });
                  setShowSnack2(true);
                  setOpenParent1(false);
                }}
                variant="contained"
                style={{ backgroundColor: "#ddd" }}
              >
                <PublishIcon />
                &nbsp;&nbsp; UPLOAD PARENT 1 DEGREE
              </Button>
            </div>
          ) : (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                variant="contained"
                onClick={() => onFileUploadParent1()}
                style={{ backgroundColor: themeStyle.primaryColor }}
              >
                <PublishIcon />
                &nbsp;&nbsp; UPLOAD PARENT 1 DEGREE
              </Button>
            </div>
          )}
        </div>
      );
    } else {
      return (
        <div>
          <h4>Choose before Pressing the Upload button</h4>
        </div>
      );
    }
  }

  function onFileUploadParent1() {
    setIsSubmitting(true);
    const formData = new FormData();
    formData.append("file", selectedFileParent1, selectedFileParent1.name);
    formData.append("form_id", formId);
    formData.append("institution_id", "CHSHRXYC");

    const config = {
      headers: {
        Authorization: state.auth.token,
      },
    };

    axios
      .post(API_URL + "/upload_parent1_degree", formData, config)
      .then(() => {
        setIsSubmitting(false);
        setParent1(true);
      })
      .catch((err) => {
        console.log("___");
        console.log(err);
        setSnack2({
          type: "ERROR",
          title: "Error!",
          message: "An error occured.",
        });
        setShowSnack2(true);
      });

    setOpenParent1(false);
    document.getElementById("contained-button-file-parent1").value = "";
  }

  function onFileChangeParent1(event) {
    setSelectedFileParent1(event.target.files[0]);
    setOpenParent1(true);
  }

  function fileDataParent2() {
    if (selectedFileParent2) {
      return (
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <h2>File Details:</h2>
            <IconButton size="small">
              <CloseIcon
                onClick={() => setOpenParent2(false)}
                style={{ color: themeStyle.primaryColor }}
              />
            </IconButton>
          </div>

          <p>File Name: {selectedFileParent2.name}</p>
          <p>File Type: {selectedFileParent2.type}</p>

          <br></br>
          <br></br>
          {selectedFileParent2.size > 25 * 1024 * 1024 ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                onClick={() => {
                  setSnack2({
                    type: "ERROR",
                    title: "Error!",
                    message: "File size should be less than 25 MB.",
                  });
                  setShowSnack2(true);
                  setOpenParent2(false);
                }}
                variant="contained"
                style={{ backgroundColor: "#ddd" }}
              >
                <PublishIcon />
                &nbsp;&nbsp; UPLOAD PARENT 2 DEGREE
              </Button>
            </div>
          ) : selectedFileParent2.name.length >= 50 ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                onClick={() => {
                  setSnack2({
                    type: "ERROR",
                    title: "Error!",
                    message: "File name too big.",
                  });
                  setShowSnack2(true);
                  setOpenParent2(false);
                }}
                variant="contained"
                style={{ backgroundColor: "#ddd" }}
              >
                <PublishIcon />
                &nbsp;&nbsp; UPLOAD PARENT 2 DEGREE
              </Button>
            </div>
          ) : (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                variant="contained"
                onClick={() => onFileUploadParent2()}
                style={{ backgroundColor: themeStyle.primaryColor }}
              >
                <PublishIcon />
                &nbsp;&nbsp; UPLOAD PARENT 2 DEGREE
              </Button>
            </div>
          )}
        </div>
      );
    } else {
      return (
        <div>
          <h4>Choose before Pressing the Upload button</h4>
        </div>
      );
    }
  }

  function onFileUploadParent2() {
    setIsSubmitting(true);
    const formData = new FormData();
    formData.append("file", selectedFileParent2, selectedFileParent2.name);
    formData.append("form_id", formId);
    formData.append("institution_id", "CHSHRXYC");

    const config = {
      headers: {
        Authorization: state.auth.token,
      },
    };

    axios
      .post(API_URL + "/upload_parent2_degree", formData, config)
      .then(() => {
        setIsSubmitting(false);
        setParent2(true);
      })
      .catch((err) => {
        console.log("___");
        console.log(err);
        setSnack2({
          type: "ERROR",
          title: "Error!",
          message: "An error occured.",
        });
        setShowSnack2(true);
      });

    setOpenParent2(false);
    document.getElementById("contained-button-file-parent2").value = "";
  }

  function onFileChangeParent2(event) {
    setSelectedFileParent2(event.target.files[0]);
    setOpenParent2(true);
  }

  function fileDataBaptism() {
    if (selectedFileBaptism) {
      return (
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <h2>File Details:</h2>
            <IconButton size="small">
              <CloseIcon
                onClick={() => setOpenBaptism(false)}
                style={{ color: themeStyle.primaryColor }}
              />
            </IconButton>
          </div>

          <p>File Name: {selectedFileBaptism.name}</p>
          <p>File Type: {selectedFileBaptism.type}</p>

          <br></br>
          <br></br>
          {selectedFileBaptism.size > 25 * 1024 * 1024 ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                onClick={() => {
                  setSnack2({
                    type: "ERROR",
                    title: "Error!",
                    message: "File size should be less than 25 MB.",
                  });
                  setShowSnack2(true);
                  setOpenBaptism(false);
                }}
                variant="contained"
                style={{ backgroundColor: "#ddd" }}
              >
                <PublishIcon />
                &nbsp;&nbsp; UPLOAD BAPTISM CERTIFICATE
              </Button>
            </div>
          ) : selectedFileBaptism.name.length >= 50 ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                onClick={() => {
                  setSnack2({
                    type: "ERROR",
                    title: "Error!",
                    message: "File name too big.",
                  });
                  setShowSnack2(true);
                  setOpenBaptism(false);
                }}
                variant="contained"
                style={{ backgroundColor: "#ddd" }}
              >
                <PublishIcon />
                &nbsp;&nbsp; UPLOAD BAPTISM CERTIFICATE
              </Button>
            </div>
          ) : (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                variant="contained"
                onClick={() => onFileUploadBaptism()}
                style={{ backgroundColor: themeStyle.primaryColor }}
              >
                <PublishIcon />
                &nbsp;&nbsp; UPLOAD BAPTISM CERTIFICATE
              </Button>
            </div>
          )}
        </div>
      );
    } else {
      return (
        <div>
          <h4>Choose before Pressing the Upload button</h4>
        </div>
      );
    }
  }

  function onFileUploadBaptism() {
    setIsSubmitting(true);
    const formData = new FormData();
    formData.append("file", selectedFileBaptism, selectedFileBaptism.name);
    formData.append("form_id", formId);
    formData.append("institution_id", "CHSHRXYC");

    const config = {
      headers: {
        Authorization: state.auth.token,
      },
    };

    axios
      .post(API_URL + "/upload_baptism_certificate", formData, config)
      .then(() => {
        setIsSubmitting(false);
        setBaptism(true);
      })
      .catch((err) => {
        console.log("___");
        console.log(err);
        setSnack2({
          type: "ERROR",
          title: "Error!",
          message: "An error occured.",
        });
        setShowSnack2(true);
      });

    setOpenBaptism(false);
    document.getElementById("contained-button-file-baptism").value = "";
  }

  function onFileChangeBaptism(event) {
    setSelectedFileBaptism(event.target.files[0]);
    setOpenBaptism(true);
  }

  function fileDataChurch() {
    if (selectedFileChurch) {
      return (
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <h2>File Details:</h2>
            <IconButton size="small">
              <CloseIcon
                onClick={() => setOpenChurch(false)}
                style={{ color: themeStyle.primaryColor }}
              />
            </IconButton>
          </div>

          <p>File Name: {selectedFileChurch.name}</p>
          <p>File Type: {selectedFileChurch.type}</p>

          <br></br>
          <br></br>
          {selectedFileChurch.size > 25 * 1024 * 1024 ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                onClick={() => {
                  setSnack2({
                    type: "ERROR",
                    title: "Error!",
                    message: "File size should be less than 25 MB.",
                  });
                  setShowSnack2(true);
                  setOpenChurch(false);
                }}
                variant="contained"
                style={{ backgroundColor: "#ddd" }}
              >
                <PublishIcon />
                &nbsp;&nbsp;UPLOAD CHURCH MEMBERSHIP
              </Button>
            </div>
          ) : selectedFileChurch.name.length >= 50 ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                onClick={() => {
                  setSnack2({
                    type: "ERROR",
                    title: "Error!",
                    message: "File name too big.",
                  });
                  setShowSnack2(true);
                  setOpenChurch(false);
                }}
                variant="contained"
                style={{ backgroundColor: "#ddd" }}
              >
                <PublishIcon />
                &nbsp;&nbsp;UPLOAD CHURCH MEMBERSHIP
              </Button>
            </div>
          ) : (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                variant="contained"
                onClick={() => onFileUploadChurch()}
                style={{ backgroundColor: themeStyle.primaryColor }}
              >
                <PublishIcon />
                &nbsp;&nbsp; UPLOAD CHURCH MEMBERSHIP
              </Button>
            </div>
          )}
        </div>
      );
    } else {
      return (
        <div>
          <h4>Choose before Pressing the Upload button</h4>
        </div>
      );
    }
  }

  function onFileUploadChurch() {
    setIsSubmitting(true);
    const formData = new FormData();
    formData.append("file", selectedFileChurch, selectedFileChurch.name);
    formData.append("form_id", formId);
    formData.append("institution_id", "CHSHRXYC");

    const config = {
      headers: {
        Authorization: state.auth.token,
      },
    };

    axios
      .post(API_URL + "/upload_church_membership", formData, config)
      .then(() => {
        setIsSubmitting(false);
        setChurch(true);
      })
      .catch((err) => {
        console.log("___");
        console.log(err);
        setSnack2({
          type: "ERROR",
          title: "Error!",
          message: "An error occured.",
        });
        setShowSnack2(true);
      });

    setOpenChurch(false);
    document.getElementById("contained-button-file-church").value = "";
  }

  function onFileChangeChurch(event) {
    setSelectedFileChurch(event.target.files[0]);
    setOpenChurch(true);
  }

  useEffect(() => {
    // Load Bolt script dynamically
    if (!boltScriptRef.current) {
      boltScriptRef.current = document.createElement("script");
      boltScriptRef.current.src =
        "https://jssdk.payu.in/bolt/static/v1/bolt.js"; // Test URL
      boltScriptRef.current.async = true;
      document.head.appendChild(boltScriptRef.current);

      boltScriptRef.current.onload = () => {
        console.log("Bolt script loaded");
      };
    }
  }, []);

  // 5nY8Jt
  // Pek9sfqLVqvSDVU5rnqEtbmtB8SrMJ7O

  const handlePayment = async () => {
    try {
      var paymentData = {
        key: "5nY8Jt",
        hash: calculateHash(
          key +
            "|" +
            txnid +
            "|" +
            "500" +
            "|BOLT|" +
            formData.student.firstName +
            "|" +
            formData.father.email +
            "|" +
            formId +
            "||||||||||Pek9sfqLVqvSDVU5rnqEtbmtB8SrMJ7O",
        ),
        txnid: txnid,
        amount: "500",
        firstname: formData.student.firstName,
        email: formData.father.email,
        phone: formData.father.mobile,
        productinfo: "BOLT",
        surl: API_URL + "/registration_success",
        furl: API_URL + "/registration_failure",
        lastname: formData.student.lastName,
        udf1: formId,
      };

      var handlers = {
        responseHandler: function (BOLT) {
          if (BOLT.response.txnStatus == "SUCCESS") {
            console.log("Your payment has been successful");
            setSnack2({
              type: "SUCCESS",
              title: "Success!",
              message:
                "Payment successful. You will be redirected to the home page now.",
            });
            setShowSnack2(true);
            axios.get(API_URL + "/get_new_form_id").then((res) => {
              setFormIdNew(res.data["form_id"]);
            });
            setFormSuccess(true);
          }
          if (BOLT.response.txnStatus == "FAILED") {
            console.log("Payment failed. Please try again.");
            setSnack2({
              type: "ERROR",
              title: "Error!",
              message: "Payment failed. Please try again.",
            });
            setShowSnack2(true);
          }
          if (BOLT.response.txnStatus == "CANCEL") {
            console.log("Payment cancelled. Please try again.");
            setSnack2({
              type: "ERROR",
              title: "Error!",
              message: "Payment cancelled. Please try again.",
            });
            setShowSnack2(true);
          }
        },
        catchException: function (BOLT) {
          console.log("Payment failed. Please try again.");
        },
      };

      setTimeout(() => {
        if (window.bolt) {
          window.bolt.launch(paymentData, handlers);
        } else {
          console.error("Bolt not loaded");
        }
      }, 1000);
    } catch (error) {
      console.error("Error fetching payment data:", error);
    }
  };

  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  function handleWindowSizeChange() {
    if (window.innerWidth <= 1300) {
      dispatch({ type: "MOBILE_VIEW", payload: true });
    } else {
      dispatch({ type: "MOBILE_VIEW", payload: false });
    }
  }

  const [showSnack2, setShowSnack2] = useState(false);
  const [snack2, setSnack2] = useState("");
  const [hash, setHash] = useState("");

  const [formData, setFormData] = useState({
    student: {
      firstName: "",
      middleName: "",
      lastName: "",
      aadharNo: "",
      dateOfBirth: "",
      gender: "MALE",
      religion: "",
      stsNumber: "",
      penNumber: "",
      motherTongue: "",
      siblingName: "",
      siblingClass: "",
      siblingDivision: "",
      placeOfBirth: "",
      permanentAddress: "",
      currentAddress: "",
      isCSI: false,
    },
    mother: {
      fullName: "",
      profession: "",
      qualification: "",
      incomePerAnnum: "",
      officeAddress: "",
      mobile: "",
      email: "",
    },
    father: {
      fullName: "",
      profession: "",
      qualification: "",
      incomePerAnnum: "",
      officeAddress: "",
      mobile: "",
      email: "",
    },
    others: {
      guardian: "",
      areParentsOldStudents: "",
      admissionFor: "",
      relationshipToGuardian: "",
      addressOfGuardian: "",
      otherInformation: "",
    },
    declaration: {
      accepted: false,
      accepted2: false,
      date: moment().format("DD-MM-YYYY"),
    },
  });

  const handleInputChange = (section, field, value) => {
    setFormData({
      ...formData,
      [section]: {
        ...formData[section],
        [field]: typeof value == "string" ? value.toUpperCase() : value,
      },
    });
  };

  function handleSubmit(e) {
    e.preventDefault();

    if (!formData.declaration.accepted || !formData.declaration.accepted2) {
      setSnack2({
        type: "ERROR",
        title: "ERROR",
        message: "Please accept the declarations before submitting.",
      });
      setShowSnack2(true);
      return;
    }
    if (photo) {
      if (birth) {
        if (parent1) {
          if (!formData.student.isCSI) {
            // Validate all required fields in formData
            const requiredFields = [
              {
                section: "student",
                key: "firstName",
                label: "Student First Name",
              },
              {
                section: "student",
                key: "lastName",
                label: "Student Last Name",
              },
              {
                section: "student",
                key: "dateOfBirth",
                label: "Date of Birth",
              },
              {
                section: "student",
                key: "placeOfBirth",
                label: "Place of Birth",
              },
              { section: "student", key: "gender", label: "Gender" },
              { section: "student", key: "religion", label: "Religion" },
              {
                section: "student",
                key: "permanentAddress",
                label: "Current Residential Address",
              },
              {
                section: "student",
                key: "religion",
                label: "Student's Religion",
              },
              { section: "father", key: "fullName", label: "Father's Name" },
              { section: "father", key: "email", label: "Father's Email" },
              { section: "father", key: "mobile", label: "Father's Mobile" },
              {
                section: "father",
                key: "qualification",
                label: "Father's Qualification",
              },
              {
                section: "father",
                key: "profession",
                label: "Father's Profession",
              },
              {
                section: "father",
                key: "incomePerAnnum",
                label: "Father's Income per Annum",
              },
              { section: "mother", key: "fullName", label: "Mother's Name" },
              { section: "mother", key: "email", label: "Mother's Email" },
              { section: "mother", key: "mobile", label: "Mother's Mobile" },
              {
                section: "mother",
                key: "profession",
                label: "Mother's Profession",
              },
              {
                section: "mother",
                key: "qualification",
                label: "Mother's Qualification",
              },
              {
                section: "mother",
                key: "incomePerAnnum",
                label: "Mother's Income per Annum",
              },
              {
                section: "others",
                key: "admissionFor",
                label: "Admission For",
              },
            ];

            for (const field of requiredFields) {
              const value = formData[field.section][field.key];
              if (!value || value.toString().trim() === "") {
                setSnack2({
                  type: "ERROR",
                  title: "ERROR",
                  message: `Please fill in ${field.label}.`,
                });
                setShowSnack2(true);
                return;
              }
            }

            var body = {};
            body["full_name"] =
              formData.student.firstName + " " + formData.student.lastName;
            body["email"] = formData.father.email;
            body["phone_number"] = formData.father.mobile;
            body["class"] = formData.others.admissionFor;
            body["form_data"] = formData;
            body["form_id"] = formId;
            axios
              .post(API_URL + "/register", JSON.stringify(body))
              .then((res) => {
                handlePayment();
              })
              .catch((err) => {});
          } else {
            if (baptism && church) {
              const requiredFields = [
                {
                  section: "student",
                  key: "firstName",
                  label: "Student First Name",
                },
                {
                  section: "student",
                  key: "lastName",
                  label: "Student Last Name",
                },
                {
                  section: "student",
                  key: "dateOfBirth",
                  label: "Date of Birth",
                },
                {
                  section: "student",
                  key: "placeOfBirth",
                  label: "Place of Birth",
                },
                { section: "student", key: "gender", label: "Gender" },
                { section: "student", key: "religion", label: "Religion" },
                {
                  section: "student",
                  key: "permanentAddress",
                  label: "Current Residential Address",
                },
                { section: "father", key: "fullName", label: "Father's Name" },
                { section: "father", key: "email", label: "Father's Email" },
                { section: "father", key: "mobile", label: "Father's Mobile" },
                { section: "mother", key: "fullName", label: "Mother's Name" },
                { section: "mother", key: "email", label: "Mother's Email" },
                { section: "mother", key: "mobile", label: "Mother's Mobile" },
                {
                  section: "others",
                  key: "admissionFor",
                  label: "Admission For",
                },
              ];

              for (const field of requiredFields) {
                const value = formData[field.section][field.key];
                if (!value || value.toString().trim() === "") {
                  setSnack2({
                    type: "ERROR",
                    title: "ERROR",
                    message: `Please fill in ${field.label}.`,
                  });
                  setShowSnack2(true);
                  return;
                }
              }

              var body = {};
              body["full_name"] =
                formData.student.firstName + " " + formData.student.lastName;
              body["email"] = formData.father.email;
              body["phone_number"] = formData.father.mobile;
              body["class"] = formData.others.admissionFor;
              body["form_data"] = formData;
              body["form_id"] = formId;
              axios
                .post(API_URL + "/register", JSON.stringify(body))
                .then((res) => {
                  handlePayment();
                })
                .catch((err) => {});
            } else {
              setSnack2({
                type: "ERROR",
                title: "ERROR",
                message:
                  "Please upload baptism certificate and church membership.",
              });
              setShowSnack2(true);
              return;
            }
          }
        } else {
          setSnack2({
            type: "ERROR",
            title: "ERROR",
            message:
              "Please upload at least 1 parent qualification certificate.",
          });
          setShowSnack2(true);
          return;
        }
      } else {
        setSnack2({
          type: "ERROR",
          title: "ERROR",
          message: "Please upload birth certificate.",
        });
        setShowSnack2(true);
        return;
      }
    } else {
      setSnack2({
        type: "ERROR",
        title: "ERROR",
        message: "Please upload photo.",
      });
      setShowSnack2(true);
      return;
    }
  }

  if (isLoading) {
    return (
      <div
        style={{
          maxWidth: "88vw",
          marginTop: "45vh",
          marginLeft: "8vw",
          height: "100%",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <CircularProgress />
      </div>
    );
  } else {
    if (formSuccess) {
      return (
        <div
          style={{
            width: "100vw",
            backgroundColor: themeStyle.primaryColor,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <AppBar
            position="fixed"
            style={{ borderRadius: "15px", backgroundColor: "white" }}
          >
            <Toolbar
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              {" "}
              <a style={{ textDecoration: "none" }} href={DOMAIN_URL}>
                <img
                  style={{ maxHeight: "50px", margin: "10px" }}
                  src={require("../img/" + APPBAR)}
                />
              </a>
            </Toolbar>
          </AppBar>
          <Snackbar
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            autoHideDuration={6000}
            open={showSnack2}
            onClose={() => setShowSnack2(false)}
          >
            <Card style={{ minWidth: "13.5vw", padding: "10px" }}>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div style={{ display: "flex" }}>
                  {snack2["type"] == "SUCCESS" ? (
                    <CheckCircleIcon
                      style={{ color: "#2ca25f", fontSize: "44px" }}
                    />
                  ) : snack2["type"] == "MESSAGE" ? (
                    <ErrorIcon
                      style={{
                        color: themeStyle.primaryColor,
                        fontSize: "44px",
                      }}
                    />
                  ) : (
                    <ErrorIcon style={{ color: "#ff3333", fontSize: "44px" }} />
                  )}
                  <div style={{ marginLeft: "10px" }}>
                    <b style={{ fontSize: "15px", textAlign: "left" }}>
                      {snack2["title"]}
                    </b>
                    <br></br>
                    <div>{snack2["message"]}</div>
                  </div>
                </div>
                <IconButton size="small" onClick={() => setShowSnack2(false)}>
                  <CloseIcon style={{ color: themeStyle.primaryColor }} />
                </IconButton>
              </div>
            </Card>
          </Snackbar>
          <div
            style={{
              borderRadius: "15px",
              width: state.auth.isMobile ? "85vw" : "60%",
              backgroundColor: "white",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                fontFamily: "Arial, sans-serif",
                lineHeight: "1.6",
                color: "#000",
                marginTop: "75px",
              }}
            >
              <div id={"pdf-element"}>
                <div
                  style={{
                    backgroundColor: themeStyle.secondaryColor,
                    padding: "0px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <img
                      style={{
                        maxHeight: "150px",
                        margin: "10px",
                        marginLeft: "-50px",
                        marginRight: "25px",
                      }}
                      src={require("../img/" + LOGOGOLDEN)}
                    />

                    <div>
                      <h1
                        style={{
                          textAlign: "center",
                          color: "#FFFDD0",
                          fontSize: "22px",
                        }}
                      >
                        {MAIN_TITLE}
                      </h1>
                      <br />
                      <h3
                        style={{
                          marginTop: "-15px",
                          textAlign: "center",
                          color: "#FFFDD0",
                          fontSize: "16px",
                        }}
                      >
                        {SUBADMISSION}
                      </h3>
                      <br />
                      <h2
                        style={{
                          marginTop: "-15px",
                          textAlign: "center",
                          color: "yellow",
                          textStyle: "bold",
                          fontSize: "16px",
                        }}
                      >
                        {ADDRESS}
                      </h2>
                      <h3
                        style={{
                          textAlign: "center",
                          color: "white",
                          fontSize: "16px",
                        }}
                      >
                        Form ID: {" " + formIdNew}
                      </h3>
                    </div>
                  </div>
                </div>
                <br />
                <div
                  style={{
                    padding: "20px",
                    marginTop: "-15px",
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyCntent: "center",
                        alignItems: "center",
                        marginTop: "5px",
                        width: state.auth.isMobile ? "150px" : "10vw",
                        height: state.auth.isMobile ? "200px" : "13.5vw",
                        backgroundColor: photo ? "#fff" : "#eee",
                        border: photo
                          ? "5px solid" + themeStyle.primaryColor
                          : "2px solid grey",
                      }}
                    >
                      <img
                        src={`${base64IMG}`}
                        alt="Photograph"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                    </div>
                  </div>
                  <h3>Student Information</h3>
                  <table
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      marginBottom: "35px",
                    }}
                  >
                    <tbody>
                      <tr>
                        <td
                          style={{
                            border: "1px solid grey",
                            padding: "8px",
                            fontWeight: "bold",
                          }}
                        >
                          First Name
                        </td>
                        <td
                          style={{ border: "1px solid grey", padding: "8px" }}
                        >
                          {formData.student.firstName}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            border: "1px solid grey",
                            padding: "8px",
                            fontWeight: "bold",
                          }}
                        >
                          Middle Name
                        </td>
                        <td
                          style={{ border: "1px solid grey", padding: "8px" }}
                        >
                          {formData.student.middleName}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            border: "1px solid grey",
                            padding: "8px",
                            fontWeight: "bold",
                          }}
                        >
                          Last Name
                        </td>
                        <td
                          style={{ border: "1px solid grey", padding: "8px" }}
                        >
                          {formData.student.lastName}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            border: "1px solid grey",
                            padding: "8px",
                            fontWeight: "bold",
                          }}
                        >
                          Aadhar Number
                        </td>
                        <td
                          style={{ border: "1px solid grey", padding: "8px" }}
                        >
                          {formData.student.aadharNo}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            border: "1px solid grey",
                            padding: "8px",
                            fontWeight: "bold",
                          }}
                        >
                          Date of Birth
                        </td>
                        <td
                          style={{ border: "1px solid grey", padding: "8px" }}
                        >
                          {formData.student.dateOfBirth}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            border: "1px solid grey",
                            padding: "8px",
                            fontWeight: "bold",
                          }}
                        >
                          Gender
                        </td>
                        <td
                          style={{ border: "1px solid grey", padding: "8px" }}
                        >
                          {formData.student.gender}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            border: "1px solid grey",
                            padding: "8px",
                            fontWeight: "bold",
                          }}
                        >
                          Religion
                        </td>
                        <td
                          style={{ border: "1px solid grey", padding: "8px" }}
                        >
                          {formData.student.religion}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            border: "1px solid grey",
                            padding: "8px",
                            fontWeight: "bold",
                          }}
                        >
                          STS Number
                        </td>
                        <td
                          style={{ border: "1px solid grey", padding: "8px" }}
                        >
                          {formData.student.stsNumber}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            border: "1px solid grey",
                            padding: "8px",
                            fontWeight: "bold",
                          }}
                        >
                          PEN Number
                        </td>
                        <td
                          style={{ border: "1px solid grey", padding: "8px" }}
                        >
                          {formData.student.penNumber}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            border: "1px solid grey",
                            padding: "8px",
                            fontWeight: "bold",
                          }}
                        >
                          Mother Tongue
                        </td>
                        <td
                          style={{ border: "1px solid grey", padding: "8px" }}
                        >
                          {formData.student.motherTongue}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            border: "1px solid grey",
                            padding: "8px",
                            fontWeight: "bold",
                          }}
                        >
                          Sibling Name
                        </td>
                        <td
                          style={{ border: "1px solid grey", padding: "8px" }}
                        >
                          {formData.student.siblingName}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            border: "1px solid grey",
                            padding: "8px",
                            fontWeight: "bold",
                          }}
                        >
                          Sibling Class
                        </td>
                        <td
                          style={{ border: "1px solid grey", padding: "8px" }}
                        >
                          {formData.student.siblingClass}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            border: "1px solid grey",
                            padding: "8px",
                            fontWeight: "bold",
                          }}
                        >
                          Sibling Division
                        </td>
                        <td
                          style={{ border: "1px solid grey", padding: "8px" }}
                        >
                          {formData.student.siblingDivision}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            border: "1px solid grey",
                            padding: "8px",
                            fontWeight: "bold",
                          }}
                        >
                          Place of Birth
                        </td>
                        <td
                          style={{ border: "1px solid grey", padding: "8px" }}
                        >
                          {formData.student.placeOfBirth}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            border: "1px solid grey",
                            padding: "8px",
                            fontWeight: "bold",
                          }}
                        >
                          Current Residential Address
                        </td>
                        <td
                          style={{ border: "1px solid grey", padding: "8px" }}
                        >
                          {formData.student.currentAddress}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            border: "1px solid grey",
                            padding: "8px",
                            fontWeight: "bold",
                          }}
                        >
                          Permanent Address
                        </td>
                        <td
                          style={{ border: "1px solid grey", padding: "8px" }}
                        >
                          {formData.student.permanentAddress}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            border: "1px solid grey",
                            padding: "8px",
                            fontWeight: "bold",
                          }}
                        >
                          Is CSI
                        </td>
                        <td
                          style={{ border: "1px solid grey", padding: "8px" }}
                        >
                          {formData.student.isCSI ? "Yes" : "No"}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div
                  style={{
                    marginTop: "50px",
                    padding: "24px",
                    marginTop: "-10px",
                  }}
                >
                  <h3>Mother Information</h3>
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        <td
                          style={{
                            border: "1px solid grey",
                            padding: "8px",
                            fontWeight: "bold",
                          }}
                        >
                          Full Name
                        </td>
                        <td
                          style={{ border: "1px solid grey", padding: "8px" }}
                        >
                          {formData.mother.fullName}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            border: "1px solid grey",
                            padding: "8px",
                            fontWeight: "bold",
                          }}
                        >
                          Profession
                        </td>
                        <td
                          style={{ border: "1px solid grey", padding: "8px" }}
                        >
                          {formData.mother.profession}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            border: "1px solid grey",
                            padding: "8px",
                            fontWeight: "bold",
                          }}
                        >
                          Qualification
                        </td>
                        <td
                          style={{ border: "1px solid grey", padding: "8px" }}
                        >
                          {formData.mother.qualification}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            border: "1px solid grey",
                            padding: "8px",
                            fontWeight: "bold",
                          }}
                        >
                          Income Per Annum
                        </td>
                        <td
                          style={{ border: "1px solid grey", padding: "8px" }}
                        >
                          {formData.mother.incomePerAnnum}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            border: "1px solid grey",
                            padding: "8px",
                            fontWeight: "bold",
                          }}
                        >
                          Office Address
                        </td>
                        <td
                          style={{ border: "1px solid grey", padding: "8px" }}
                        >
                          {formData.mother.officeAddress}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            border: "1px solid grey",
                            padding: "8px",
                            fontWeight: "bold",
                          }}
                        >
                          Mobile
                        </td>
                        <td
                          style={{ border: "1px solid grey", padding: "8px" }}
                        >
                          {formData.mother.mobile}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            border: "1px solid grey",
                            padding: "8px",
                            fontWeight: "bold",
                          }}
                        >
                          Email
                        </td>
                        <td
                          style={{ border: "1px solid grey", padding: "8px" }}
                        >
                          {formData.mother.email}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div style={{ padding: "24px", marginTop: "-15px" }}>
                  <h3>Father Information</h3>
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        <td
                          style={{
                            border: "1px solid grey",
                            padding: "8px",
                            fontWeight: "bold",
                          }}
                        >
                          Full Name
                        </td>
                        <td
                          style={{ border: "1px solid grey", padding: "8px" }}
                        >
                          {formData.father.fullName}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            border: "1px solid grey",
                            padding: "8px",
                            fontWeight: "bold",
                          }}
                        >
                          Profession
                        </td>
                        <td
                          style={{ border: "1px solid grey", padding: "8px" }}
                        >
                          {formData.father.profession}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            border: "1px solid grey",
                            padding: "8px",
                            fontWeight: "bold",
                          }}
                        >
                          Qualification
                        </td>
                        <td
                          style={{ border: "1px solid grey", padding: "8px" }}
                        >
                          {formData.father.qualification}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            border: "1px solid grey",
                            padding: "8px",
                            fontWeight: "bold",
                          }}
                        >
                          Income Per Annum
                        </td>
                        <td
                          style={{ border: "1px solid grey", padding: "8px" }}
                        >
                          {formData.father.incomePerAnnum}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            border: "1px solid grey",
                            padding: "8px",
                            fontWeight: "bold",
                          }}
                        >
                          Office Address
                        </td>
                        <td
                          style={{ border: "1px solid grey", padding: "8px" }}
                        >
                          {formData.father.officeAddress}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            border: "1px solid grey",
                            padding: "8px",
                            fontWeight: "bold",
                          }}
                        >
                          Mobile
                        </td>
                        <td
                          style={{ border: "1px solid grey", padding: "8px" }}
                        >
                          {formData.father.mobile}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            border: "1px solid grey",
                            padding: "8px",
                            fontWeight: "bold",
                          }}
                        >
                          Email
                        </td>
                        <td
                          style={{ border: "1px solid grey", padding: "8px" }}
                        >
                          {formData.father.email}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div
                  style={{
                    marginBottom: "24px",
                    padding: "24px",
                    marginTop: "-15px",
                  }}
                >
                  <h3>Other Information</h3>
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        <td
                          style={{
                            border: "1px solid grey",
                            padding: "8px",
                            fontWeight: "bold",
                          }}
                        >
                          Guardian
                        </td>
                        <td
                          style={{ border: "1px solid grey", padding: "8px" }}
                        >
                          {formData.others.guardian}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            border: "1px solid grey",
                            padding: "8px",
                            fontWeight: "bold",
                          }}
                        >
                          Are Parents Old Students
                        </td>
                        <td
                          style={{ border: "1px solid grey", padding: "8px" }}
                        >
                          {formData.others.areParentsOldStudents}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            border: "1px solid grey",
                            padding: "8px",
                            fontWeight: "bold",
                          }}
                        >
                          Admission For
                        </td>
                        <td
                          style={{ border: "1px solid grey", padding: "8px" }}
                        >
                          {formData.others.admissionFor}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            border: "1px solid grey",
                            padding: "8px",
                            fontWeight: "bold",
                          }}
                        >
                          Relationship to Guardian
                        </td>
                        <td
                          style={{ border: "1px solid grey", padding: "8px" }}
                        >
                          {formData.others.relationshipToGuardian}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            border: "1px solid grey",
                            padding: "8px",
                            fontWeight: "bold",
                          }}
                        >
                          Address of Guardian
                        </td>
                        <td
                          style={{ border: "1px solid grey", padding: "8px" }}
                        >
                          {formData.others.addressOfGuardian}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            border: "1px solid grey",
                            padding: "8px",
                            fontWeight: "bold",
                          }}
                        >
                          Other Information
                        </td>
                        <td
                          style={{ border: "1px solid grey", padding: "8px" }}
                        >
                          {formData.others.otherInformation}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            border: "1px solid grey",
                            padding: "8px",
                            fontWeight: "bold",
                          }}
                        >
                          Date
                        </td>
                        <td
                          style={{ border: "1px solid grey", padding: "8px" }}
                        >
                          {moment().format("DD-MM-YYYY")}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <br />
                  <br />
                  <br />
                  <br />
                  <Typography variant="h6">Criteria for admission</Typography>
                  <div style={{ textAlign: "left", marginTop: "15px" }}>
                    <p>
                      1. Age criteria: The child should be 4 years as on June
                      01, 2026. The minimum age should be 4 years and the
                      maximum age permissible shall be 5 years. Attested copies
                      of the Birth Certificate issued by the Corporation must
                      bear the name of the child.{" "}
                    </p>
                    <p>
                      2. CSI candidates must submit additional documents such as
                      Baptism Certificate and the parent's Church membership
                      letter. They shall be members of the KCD Church for a
                      minimum period of five years.
                    </p>
                    <p>
                      3. As proof of residence a photocopy of either the Voter
                      ID, Passport, Aadhaar Card or rental agreement must be
                      submitted.
                    </p>
                    <p>
                      4. Attested copies of both the parents' highest
                      educational qualification is mandatory
                    </p>
                  </div>
                  <br />
                  <Typography variant="h6">Declaration</Typography>
                  <br />
                  <div style={{ textAlign: "left" }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={true}
                          style={{
                            transform: "scale(1.5)",
                            color: themeStyle.primaryColor,
                          }}
                          onChange={() => {}}
                        />
                      }
                      label={
                        "I agree to comply with all the rules and regulations of the Institution as prescribed and to meet all financial obligations incurred by my child's attendance at " +
                        MAIN_TITLE
                      }
                    />{" "}
                    <br />
                    <br />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={true}
                          style={{
                            transform: "scale(1.5)",
                            color: themeStyle.primaryColor,
                          }}
                          onChange={() => {}}
                        />
                      }
                      label="I herewith declare that all the information furnished by me in this application is true to the best of my knowledge. I also herewith declare that i will not claim any refund of any of the payments under any circumstances"
                    />
                  </div>
                  <br /> <br />
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "100%",
                    }}
                  >
                    <div>Date: </div>
                    <div
                      style={{ width: "500px", borderTop: "2px solid black" }}
                    >
                      Signature of Parent / Guardian
                    </div>
                  </div>
                  <br /> <br />
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "100%",
                    }}
                  >
                    <div>Date: </div>
                    <div
                      style={{ width: "500px", borderTop: "2px solid black" }}
                    >
                      Signature of Principal
                    </div>
                  </div>
                  <br /> <br />
                  <hr />
                  <div style={{ fontWeight: "bold", fontSize: "20px" }}>
                    FOR OFFICE USE ONLY
                  </div>
                  <br />
                  <div>
                    1) Birth Certificate (copy) <br /> <br />
                    2) Transfer Certificate / School Leaving Certificate <br />{" "}
                    <br />
                    3) Progress Report <br /> <br /> 4) Aadhar Card (copy)
                    <br /> <br /> 5) Fees paid <br />
                    Amount: ____________
                  </div>
                  <br />
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "100%",
                    }}
                  >
                    <div>Date: </div>
                    <div
                      style={{ width: "500px", borderTop: "2px solid black" }}
                    >
                      Signature of the receiving authority
                    </div>
                  </div>
                </div>
              </div>
              <Button
                style={{
                  height: "35px",
                  margin: "6px 0px 15px 0px",
                  border: "1px solid #3182bd",
                  backgroundColor: themeStyle.primaryColor,
                  boxShadow: "none",
                }}
                variant={"contained"}
                fullWidth
                onClick={() => {
                  setIsLoadingDownload(true);
                  var element = document.getElementById("pdf-element");
                  html2pdf(element).then((_) => {
                    setIsLoadingDownload(false);
                    setSnack2({
                      type: "SUCCESS",
                      title: "Success!",
                      message: "Download successful.",
                    });
                    setShowSnack2(true);
                  });
                }}
              >
                <h4>Download PDF</h4>
              </Button>
              {isLoadingDownload ? (
                <div
                  style={{
                    borderRadius: "15px",
                    marginTop: "20px",
                    padding: "20px",
                    width: "100%",
                    backgroundColor: "white",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                  }}
                >
                  <CircularProgress />
                  <h3 style={{ textAlign: "center" }}>
                    Downloading attendance
                    <br />
                    This might take a couple of minutes...
                  </h3>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div
          style={{
            width: "100vw",
            backgroundColor: themeStyle.primaryColor,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <AppBar
            position="fixed"
            style={{ borderRadius: "15px", backgroundColor: "white" }}
          >
            <Toolbar
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              {" "}
              <a style={{ textDecoration: "none" }} href={DOMAIN_URL}>
                <img
                  style={{ maxHeight: "50px", margin: "10px" }}
                  src={require("../img/" + APPBAR)}
                />
              </a>
            </Toolbar>
          </AppBar>
          <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={openPhoto}
            onClose={() => setOpenPhoto(false)}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
              timeout: 500,
            }}
          >
            <Fade in={openPhoto}>
              <div
                style={{
                  borderRadius: "15px",
                  position: "absolute",
                  top: "50%",
                  backgroundColor: "white",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: state.auth.isMobile ? "90vw" : 400,
                  padding: "20px",
                }}
              >
                {fileDataPhoto()}
              </div>
            </Fade>
          </Modal>
          <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={openBirth}
            onClose={() => setOpenBirth(false)}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
              timeout: 500,
            }}
          >
            <Fade in={openBirth}>
              <div
                style={{
                  borderRadius: "15px",
                  position: "absolute",
                  top: "50%",
                  backgroundColor: "white",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: state.auth.isMobile ? "90vw" : 400,
                  padding: "20px",
                }}
              >
                {fileDataBirth()}
              </div>
            </Fade>
          </Modal>
          <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={openLeaving}
            onClose={() => setOpenLeaving(false)}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
              timeout: 500,
            }}
          >
            <Fade in={openLeaving}>
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  backgroundColor: "white",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: state.auth.isMobile ? "90vw" : 400,
                  padding: "20px",
                  borderRadius: "15px",
                }}
              >
                {fileDataLeaving()}
              </div>
            </Fade>
          </Modal>
          <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={openProgress}
            onClose={() => setOpenProgress(false)}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
              timeout: 500,
            }}
          >
            <Fade in={openProgress}>
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  backgroundColor: "white",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: state.auth.isMobile ? "90vw" : 400,
                  padding: "20px",
                  borderRadius: "15px",
                }}
              >
                {fileDataProgress()}
              </div>
            </Fade>
          </Modal>
          <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={openAadhar}
            onClose={() => setOpenAadhar(false)}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
              timeout: 500,
            }}
          >
            <Fade in={openAadhar}>
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  backgroundColor: "white",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: state.auth.isMobile ? "90vw" : 400,
                  padding: "20px",
                  borderRadius: "15px",
                }}
              >
                {fileDataAadhar()}
              </div>
            </Fade>
          </Modal>
          <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={openParent1}
            onClose={() => setOpenParent1(false)}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
              timeout: 500,
            }}
          >
            <Fade in={openParent1}>
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  backgroundColor: "white",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: state.auth.isMobile ? "90vw" : 400,
                  padding: "20px",
                  borderRadius: "15px",
                }}
              >
                {fileDataParent1()}
              </div>
            </Fade>
          </Modal>
          <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={openParent2}
            onClose={() => setOpenParent2(false)}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
              timeout: 500,
            }}
          >
            <Fade in={openParent2}>
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  backgroundColor: "white",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: state.auth.isMobile ? "90vw" : 400,
                  padding: "20px",
                  borderRadius: "15px",
                }}
              >
                {fileDataParent2()}
              </div>
            </Fade>
          </Modal>
          <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={openBaptism}
            onClose={() => setOpenBaptism(false)}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
              timeout: 500,
            }}
          >
            <Fade in={openBaptism}>
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  backgroundColor: "white",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: state.auth.isMobile ? "90vw" : 400,
                  padding: "20px",
                  borderRadius: "15px",
                }}
              >
                {fileDataBaptism()}
              </div>
            </Fade>
          </Modal>
          <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={openChurch}
            onClose={() => setOpenChurch(false)}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
              timeout: 500,
            }}
          >
            <Fade in={openChurch}>
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  backgroundColor: "white",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: state.auth.isMobile ? "90vw" : 400,
                  padding: "20px",
                  borderRadius: "15px",
                }}
              >
                {fileDataChurch()}
              </div>
            </Fade>
          </Modal>
          <Snackbar
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            autoHideDuration={6000}
            open={showSnack2}
            onClose={() => setShowSnack2(false)}
          >
            <Card style={{ minWidth: "13.5vw", padding: "10px" }}>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div style={{ display: "flex" }}>
                  {snack2["type"] == "SUCCESS" ? (
                    <CheckCircleIcon
                      style={{ color: "#2ca25f", fontSize: "44px" }}
                    />
                  ) : snack2["type"] == "MESSAGE" ? (
                    <ErrorIcon
                      style={{
                        color: themeStyle.primaryColor,
                        fontSize: "44px",
                      }}
                    />
                  ) : (
                    <ErrorIcon style={{ color: "#ff3333", fontSize: "44px" }} />
                  )}
                  <div style={{ marginLeft: "10px" }}>
                    <b style={{ fontSize: "15px", textAlign: "left" }}>
                      {snack2["title"]}
                    </b>
                    <br></br>
                    <div>{snack2["message"]}</div>
                  </div>
                </div>
                <IconButton size="small" onClick={() => setShowSnack2(false)}>
                  <CloseIcon style={{ color: themeStyle.primaryColor }} />
                </IconButton>
              </div>
            </Card>
          </Snackbar>
          <div
            style={{
              borderRadius: "15px",
              width: state.auth.isMobile ? "85vw" : "60%",
              backgroundColor: "white",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              padding: state.auth.isMobile ? "5px" : "10px",
            }}
          >
            {state.auth.isMobile ? (
              <div
                style={{
                  backgroundColor: themeStyle.secondaryColor,
                  padding: "10px",
                  paddingTop: "85px",
                  width: "100%",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                    flexDirection: "column",
                  }}
                >
                  <img
                    style={{
                      maxHeight: "150px",
                      margin: "10px",
                      marginRight: "50px",
                    }}
                    src={require("../img/" + LOGOGOLDEN)}
                  />
                  <div>
                    <h1
                      style={{
                        textAlign: "center",
                        color: "#FFFDD0",
                      }}
                    >
                      {MAIN_TITLE}
                    </h1>
                    <h3
                      style={{
                        marginTop: "-15px",
                        textAlign: "center",
                        color: "#FFFDD0",
                      }}
                    >
                      {SUBADMISSION}
                    </h3>

                    <h2
                      style={{
                        marginTop: "-15px",
                        textAlign: "center",
                        color: "yellow",
                        textStyle: "bold",
                      }}
                    >
                      No.63, Richmond Road, Bangalore - 560 025
                    </h2>
                  </div>
                </div>
              </div>
            ) : (
              <div
                style={{
                  backgroundColor: themeStyle.secondaryColor,
                  padding: "10px",
                  paddingTop: "85px",
                  width: "100%",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  <img
                    style={{
                      maxHeight: "150px",
                      margin: "10px",
                      marginRight: "50px",
                    }}
                    src={require("../img/" + LOGOGOLDEN)}
                  />
                  <div>
                    <h1
                      style={{
                        textAlign: "center",
                        color: "#FFFDD0",
                      }}
                    >
                      {MAIN_TITLE}
                    </h1>
                    <h3
                      style={{
                        marginTop: "-15px",
                        textAlign: "center",
                        color: "#FFFDD0",
                      }}
                    >
                      {SUBADMISSION}
                    </h3>
                    <h3
                      style={{
                        marginTop: "-15px",
                        textAlign: "center",
                        color: "#FFFDD0",
                      }}
                    >
                      {ADDRESS}
                    </h3>
                  </div>
                </div>
              </div>
            )}
            <br />
            <Box
              style={{
                marginTop: "50px",
                marginBottom: "200px",
              }}
              component="form"
              onSubmit={handleSubmit}
              p={state.auth.isMobile ? 0 : 3}
            >
              <Typography variant="h4" gutterBottom>
                Student Registration Form
              </Typography>
              <Typography variant="h6">Student Personal Details</Typography>
              <p>Fields marked with * are compulsary</p>
              <br />
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <label
                  style={{ width: state.auth.isMobile ? "250px" : "10vw" }}
                  htmlFor="contained-button-file-photo"
                >
                  <input
                    style={{ display: "none" }}
                    id="contained-button-file-photo"
                    type="file"
                    onChange={(e) => onFileChangePhoto(e)}
                  />
                  <ButtonBase
                    style={{
                      width: state.auth.isMobile ? "250px" : "10vw",
                      display: "flex",
                      justifyCntent: "center",
                      alignItems: "center",
                      flexDirection: "column",
                      cursor: "pointer",
                    }}
                    component="div"
                  >
                    <div>Photograph *</div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyCntent: "center",
                        alignItems: "center",
                        marginTop: "5px",
                        width: state.auth.isMobile ? "250px" : "10vw",
                        height: state.auth.isMobile ? "350px" : "13.5vw",
                        backgroundColor: photo ? "#fff" : "#eee",
                        border: photo
                          ? "5px solid" + themeStyle.primaryColor
                          : "2px solid grey",
                      }}
                    >
                      {photo ? (
                        <img
                          src={API_URL + "/media/" + formId + "_photo.jpg"}
                          alt="Photograph"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      ) : (
                        <AddIcon
                          style={{
                            marginTop: "50px",
                            fontSize: "140px",
                            color: themeStyle.primaryColor,
                          }}
                        />
                      )}
                    </div>
                  </ButtonBase>
                </label>
              </div>
              <br />
              <br />
              <Grid container spacing={state.auth.isMobile ? 2 : 3}>
                <Grid item xs={12} sm={4}>
                  <div
                    style={{
                      color: themeStyle.primaryColor,
                      fontSize: "14px",
                      marginBottom: "10px",
                    }}
                  >
                    First Name *
                  </div>

                  <TextField
                    label="First Name"
                    fullWidth
                    value={formData.student.firstName}
                    onChange={(e) =>
                      handleInputChange("student", "firstName", e.target.value)
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <div
                    style={{
                      color: themeStyle.primaryColor,
                      fontSize: "14px",
                      marginBottom: "10px",
                    }}
                  >
                    Middle Name
                  </div>
                  <TextField
                    label="Middle Name"
                    fullWidth
                    value={formData.student.middleName}
                    onChange={(e) =>
                      handleInputChange("student", "middleName", e.target.value)
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <div
                    style={{
                      color: themeStyle.primaryColor,
                      fontSize: "14px",
                      marginBottom: "10px",
                    }}
                  >
                    Last Name *
                  </div>
                  <TextField
                    label="Last Name"
                    fullWidth
                    value={formData.student.lastName}
                    onChange={(e) =>
                      handleInputChange("student", "lastName", e.target.value)
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <div
                    style={{
                      color: themeStyle.primaryColor,
                      fontSize: "14px",
                      marginBottom: "10px",
                    }}
                  >
                    Aadhar Number
                  </div>
                  <TextField
                    label="Aadhar Number"
                    fullWidth
                    value={formData.student.aadharNo}
                    onChange={(e) =>
                      handleInputChange("student", "aadharNo", e.target.value)
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <div
                    style={{
                      color: themeStyle.primaryColor,
                      fontSize: "14px",
                      marginBottom: "10px",
                    }}
                  >
                    Date of Birth *
                  </div>
                  <TextField
                    label="Date of Birth"
                    type="date"
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    value={formData.student.dateOfBirth}
                    onChange={(e) =>
                      handleInputChange(
                        "student",
                        "dateOfBirth",
                        e.target.value,
                      )
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <div
                    style={{
                      color: themeStyle.primaryColor,
                      fontSize: "14px",
                      marginBottom: "10px",
                    }}
                  >
                    Place of Birth *
                  </div>
                  <TextField
                    label="Place of Birth"
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    value={formData.student.placeOfBirth}
                    onChange={(e) =>
                      handleInputChange(
                        "student",
                        "placeOfBirth",
                        e.target.value,
                      )
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <div
                    style={{
                      color: themeStyle.primaryColor,
                      fontSize: "14px",
                      marginBottom: "10px",
                    }}
                  >
                    Gender *
                  </div>
                  <TextField
                    label="Gender"
                    select
                    fullWidth
                    value={formData.student.gender}
                    onChange={(e) =>
                      handleInputChange("student", "gender", e.target.value)
                    }
                  >
                    <MenuItem value="MALE">MALE</MenuItem>
                    <MenuItem value="FEMALE">FEMALE</MenuItem>
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <div
                    style={{
                      color: themeStyle.primaryColor,
                      fontSize: "14px",
                      marginBottom: "10px",
                    }}
                  >
                    Mention your Religion, Caste and/or Subcaste *
                  </div>
                  <TextField
                    label="Religion and Caste"
                    fullWidth
                    value={formData.student.religion}
                    onChange={(e) =>
                      handleInputChange("student", "religion", e.target.value)
                    }
                  />
                </Grid>
                {formData.student.religion
                  .toLowerCase()
                  .includes("christian") ? (
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <div style={{ textAlign: "left", marginTop: "15px" }}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={formData.student.isCSI}
                            style={{
                              transform: "scale(1.5)",
                              color: themeStyle.primaryColor,
                            }}
                            onChange={(e) =>
                              handleInputChange(
                                "student",
                                "isCSI",
                                e.target.checked,
                              )
                            }
                          />
                        }
                        label="CSI Category"
                      />{" "}
                    </div>
                  </Grid>
                ) : (
                  ""
                )}
                <Grid item xs={12} sm={6}>
                  <div
                    style={{
                      color: themeStyle.primaryColor,
                      fontSize: "14px",
                      marginBottom: "10px",
                    }}
                  >
                    STS Number
                  </div>
                  <TextField
                    label="STS Number"
                    fullWidth
                    value={formData.student.stsNumber}
                    onChange={(e) =>
                      handleInputChange("student", "stsNumber", e.target.value)
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <div
                    style={{
                      color: themeStyle.primaryColor,
                      fontSize: "14px",
                      marginBottom: "10px",
                    }}
                  >
                    PEN Number
                  </div>
                  <TextField
                    label="PEN Number"
                    fullWidth
                    value={formData.student.penNumber}
                    onChange={(e) =>
                      handleInputChange("student", "penNumber", e.target.value)
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <div
                    style={{
                      color: themeStyle.primaryColor,
                      fontSize: "14px",
                      marginBottom: "10px",
                    }}
                  >
                    Mother Tongue
                  </div>
                  <TextField
                    label="Mother Tongue"
                    fullWidth
                    value={formData.student.motherTongue}
                    onChange={(e) =>
                      handleInputChange(
                        "student",
                        "motherTongue",
                        e.target.value,
                      )
                    }
                  />
                </Grid>
                <Grid item xs={12}>
                  <div
                    style={{
                      color: themeStyle.primaryColor,
                      fontSize: "14px",
                      marginBottom: "10px",
                    }}
                  >
                    Current Residential Address *
                  </div>
                  <TextField
                    label="Current Residential Address"
                    fullWidth
                    multiline
                    rows={1}
                    value={formData.student.currentAddress}
                    onChange={(e) =>
                      handleInputChange(
                        "student",
                        "currentAddress",
                        e.target.value,
                      )
                    }
                  />
                </Grid>
                <Grid item xs={12}>
                  <div
                    style={{
                      color: themeStyle.primaryColor,
                      fontSize: "14px",
                      marginBottom: "10px",
                    }}
                  >
                    Permanent Address *
                  </div>
                  <TextField
                    label="Permanent Address"
                    fullWidth
                    multiline
                    rows={1}
                    value={formData.student.permanentAddress}
                    onChange={(e) =>
                      handleInputChange(
                        "student",
                        "permanentAddress",
                        e.target.value,
                      )
                    }
                  />
                </Grid>
                <br />
                <br />
                <br />
                <br />
                <div style={{ textAlign: "center", marginTop: "25px" }}>
                  If any siblings studying in {MAIN_TITLE}, please mention their
                  name and class
                </div>
                <Grid item xs={12}>
                  <div
                    style={{
                      color: themeStyle.primaryColor,
                      fontSize: "14px",
                      marginBottom: "5px",
                    }}
                  >
                    Siblings in {MAIN_TITLE}
                  </div>
                  <TextField
                    label="Siblings, if any, their full name"
                    style={{ marginTop: "10px" }}
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    value={formData.student.siblingName}
                    onChange={(e) =>
                      handleInputChange(
                        "student",
                        "siblingName",
                        e.target.value,
                      )
                    }
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <div
                    style={{
                      color: themeStyle.primaryColor,
                      fontSize: "14px",
                      marginBottom: "10px",
                    }}
                  >
                    Sibling Class
                  </div>
                  <TextField
                    label="Sibling Class"
                    select
                    fullWidth
                    value={formData.student.siblingClass}
                    onChange={(e) =>
                      handleClassChange("student", "siblingClass", e)
                    }
                  >
                    <MenuItem value={"PKG"}>PKG</MenuItem>
                    <MenuItem value={"LKG"}>LKG</MenuItem>
                    <MenuItem value={"UKG"}>UKG</MenuItem>
                    <MenuItem value={"Class 1"}>Class 1</MenuItem>
                    <MenuItem value={"Class 2"}>Class 2</MenuItem>
                    <MenuItem value={"Class 3"}>Class 3</MenuItem>
                    <MenuItem value={"Class 4"}>Class 4</MenuItem>
                    <MenuItem value={"Class 5"}>Class 5</MenuItem>
                    <MenuItem value={"Class 6"}>Class 6</MenuItem>
                    <MenuItem value={"Class 7"}>Class 7</MenuItem>
                    <MenuItem value={"Class 8"}>Class 8</MenuItem>
                    <MenuItem value={"Class 9"}>Class 9</MenuItem>
                    <MenuItem value={"Class 10"}>Class 10</MenuItem>
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <div
                    style={{
                      color: themeStyle.primaryColor,
                      fontSize: "14px",
                      marginBottom: "10px",
                    }}
                  >
                    Sibling Division
                  </div>
                  <TextField
                    label="Sibling Division"
                    select
                    fullWidth
                    value={formData.student.siblingDivision}
                    onChange={(e) =>
                      handleDivisionChange("student", "siblingDivision", e)
                    }
                  >
                    {getDivisionList()}
                  </TextField>
                </Grid>
              </Grid>
              <Typography variant="h6" sx={{ mt: 4 }}>
                Father's Details
              </Typography>
              <br />
              <Grid container spacing={state.auth.isMobile ? 2 : 3}>
                <Grid item xs={12}>
                  <div
                    style={{
                      color: themeStyle.primaryColor,
                      fontSize: "14px",
                      marginBottom: "10px",
                    }}
                  >
                    Father's Name *
                  </div>
                  <TextField
                    label="Father's Name"
                    fullWidth
                    value={formData.father.fullName}
                    onChange={(e) =>
                      handleInputChange("father", "fullName", e.target.value)
                    }
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <div
                    style={{
                      color: themeStyle.primaryColor,
                      fontSize: "14px",
                      marginBottom: "10px",
                    }}
                  >
                    Profession *
                  </div>
                  <TextField
                    label="Profession"
                    fullWidth
                    value={formData.father.profession}
                    onChange={(e) =>
                      handleInputChange("father", "profession", e.target.value)
                    }
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <div
                    style={{
                      color: themeStyle.primaryColor,
                      fontSize: "14px",
                      marginBottom: "10px",
                    }}
                  >
                    Qualification *
                  </div>
                  <TextField
                    label="Qualification"
                    fullWidth
                    value={formData.father.qualification}
                    onChange={(e) =>
                      handleInputChange(
                        "father",
                        "qualification",
                        e.target.value,
                      )
                    }
                  />
                </Grid>

                <Grid item xs={12}>
                  <div
                    style={{
                      color: themeStyle.primaryColor,
                      fontSize: "14px",
                      marginBottom: "10px",
                    }}
                  >
                    Income Per Annum *
                  </div>
                  <TextField
                    label="Income Per Annum"
                    fullWidth
                    value={formData.father.incomePerAnnum}
                    onChange={(e) =>
                      handleInputChange(
                        "father",
                        "incomePerAnnum",
                        e.target.value,
                      )
                    }
                  />
                </Grid>
                <Grid item xs={12}>
                  <div
                    style={{
                      color: themeStyle.primaryColor,
                      fontSize: "14px",
                      marginBottom: "10px",
                    }}
                  >
                    Office Address
                  </div>
                  <TextField
                    label="Office Address"
                    fullWidth
                    value={formData.father.officeAddress}
                    onChange={(e) =>
                      handleInputChange(
                        "father",
                        "officeAddress",
                        e.target.value,
                      )
                    }
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <div
                    style={{
                      color: themeStyle.primaryColor,
                      fontSize: "14px",
                      marginBottom: "10px",
                    }}
                  >
                    Mobile Number *
                  </div>
                  <TextField
                    label="Mobile Number"
                    fullWidth
                    value={formData.father.mobile}
                    onChange={(e) =>
                      handleInputChange("father", "mobile", e.target.value)
                    }
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <div
                    style={{
                      color: themeStyle.primaryColor,
                      fontSize: "14px",
                      marginBottom: "10px",
                    }}
                  >
                    Email ID *
                  </div>
                  <TextField
                    label="Email ID"
                    type="email"
                    fullWidth
                    value={formData.father.email}
                    onChange={(e) =>
                      handleInputChange("father", "email", e.target.value)
                    }
                  />
                </Grid>
              </Grid>
              <Typography variant="h6" sx={{ mt: 4 }}>
                Mother's Details
              </Typography>
              <br />
              <Grid container spacing={state.auth.isMobile ? 2 : 3}>
                <Grid item xs={12}>
                  <div
                    style={{
                      color: themeStyle.primaryColor,
                      fontSize: "14px",
                      marginBottom: "10px",
                    }}
                  >
                    Mother's Name *
                  </div>
                  <TextField
                    label="Mother's Name"
                    fullWidth
                    value={formData.mother.fullName}
                    onChange={(e) =>
                      handleInputChange("mother", "fullName", e.target.value)
                    }
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <div
                    style={{
                      color: themeStyle.primaryColor,
                      fontSize: "14px",
                      marginBottom: "10px",
                    }}
                  >
                    Profession *
                  </div>
                  <TextField
                    label="Profession"
                    fullWidth
                    value={formData.mother.profession}
                    onChange={(e) =>
                      handleInputChange("mother", "profession", e.target.value)
                    }
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <div
                    style={{
                      color: themeStyle.primaryColor,
                      fontSize: "14px",
                      marginBottom: "10px",
                    }}
                  >
                    Qualification *
                  </div>
                  <TextField
                    label="Qualification"
                    fullWidth
                    value={formData.mother.qualification}
                    onChange={(e) =>
                      handleInputChange(
                        "mother",
                        "qualification",
                        e.target.value,
                      )
                    }
                  />
                </Grid>

                <Grid item xs={12}>
                  <div
                    style={{
                      color: themeStyle.primaryColor,
                      fontSize: "14px",
                      marginBottom: "10px",
                    }}
                  >
                    Income Per Annum *
                  </div>
                  <TextField
                    label="Income Per Annum"
                    fullWidth
                    value={formData.mother.incomePerAnnum}
                    onChange={(e) =>
                      handleInputChange(
                        "mother",
                        "incomePerAnnum",
                        e.target.value,
                      )
                    }
                  />
                </Grid>
                <Grid item xs={12}>
                  <div
                    style={{
                      color: themeStyle.primaryColor,
                      fontSize: "14px",
                      marginBottom: "10px",
                    }}
                  >
                    Office Address
                  </div>
                  <TextField
                    label="Office Address"
                    fullWidth
                    value={formData.mother.officeAddress}
                    onChange={(e) =>
                      handleInputChange(
                        "mother",
                        "officeAddress",
                        e.target.value,
                      )
                    }
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <div
                    style={{
                      color: themeStyle.primaryColor,
                      fontSize: "14px",
                      marginBottom: "10px",
                    }}
                  >
                    Mobile Number *
                  </div>
                  <TextField
                    label="Mobile Number"
                    fullWidth
                    value={formData.mother.mobile}
                    onChange={(e) =>
                      handleInputChange("mother", "mobile", e.target.value)
                    }
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <div
                    style={{
                      color: themeStyle.primaryColor,
                      fontSize: "14px",
                      marginBottom: "10px",
                    }}
                  >
                    Email ID *
                  </div>
                  <TextField
                    label="Email ID"
                    type="email"
                    fullWidth
                    value={formData.mother.email}
                    onChange={(e) =>
                      handleInputChange("mother", "email", e.target.value)
                    }
                  />
                </Grid>
              </Grid>
              <Typography variant="h6" sx={{ mt: 4 }}>
                Other Details
              </Typography>
              <br />
              <Grid container spacing={state.auth.isMobile ? 2 : 3}>
                <div
                  style={{
                    color: themeStyle.primaryColor,
                    fontSize: "14px",
                    marginBottom: "10px",
                  }}
                >
                  Select CLASS *
                </div>
                <Grid item xs={12}>
                  <TextField
                    label="Admission For"
                    select
                    fullWidth
                    value={formData.others.admissionFor}
                    onChange={(e) =>
                      handleClassChange("others", "admissionFor", e)
                    }
                  >
                    <MenuItem value={"PKG"}>PKG</MenuItem>
                    <MenuItem value={"LKG"}>LKG</MenuItem>
                    <MenuItem value={"UKG"}>UKG</MenuItem>
                    <MenuItem value={"Class 1"}>Class 1</MenuItem>
                    <MenuItem value={"Class 2"}>Class 2</MenuItem>
                    <MenuItem value={"Class 3"}>Class 3</MenuItem>
                    <MenuItem value={"Class 4"}>Class 4</MenuItem>
                    <MenuItem value={"Class 5"}>Class 5</MenuItem>
                    <MenuItem value={"Class 6"}>Class 6</MenuItem>
                    <MenuItem value={"Class 7"}>Class 7</MenuItem>
                    <MenuItem value={"Class 8"}>Class 8</MenuItem>
                    <MenuItem value={"Class 9"}>Class 9</MenuItem>
                  </TextField>
                </Grid>

                <Grid item xs={12}>
                  <div
                    style={{
                      color: themeStyle.primaryColor,
                      fontSize: "14px",
                      marginBottom: "10px",
                    }}
                  >
                    Parent Alumni Status
                  </div>
                  <TextField
                    label="Are Parents Old Students? If Yes then give particulars"
                    fullWidth
                    value={formData.others.areParentsOldStudents}
                    onChange={(e) =>
                      handleInputChange(
                        "others",
                        "areParentsOldStudents",
                        e.target.value,
                      )
                    }
                  />
                </Grid>
                <Grid item xs={12}>
                  <div
                    style={{
                      color: themeStyle.primaryColor,
                      fontSize: "14px",
                      marginBottom: "10px",
                    }}
                  >
                    Guardian
                  </div>
                  <TextField
                    label="Guardian, if applicable"
                    fullWidth
                    value={formData.others.guardian}
                    onChange={(e) =>
                      handleInputChange("others", "guardian", e.target.value)
                    }
                  />
                </Grid>
                <Grid item xs={12}>
                  <div
                    style={{
                      color: themeStyle.primaryColor,
                      fontSize: "14px",
                      marginBottom: "10px",
                    }}
                  >
                    Relationship to Guardian
                  </div>
                  <TextField
                    label="Relationship to candidate of the Guardian"
                    fullWidth
                    value={formData.others.relationshipToGuardian}
                    onChange={(e) =>
                      handleInputChange(
                        "others",
                        "relationshipToGuardian",
                        e.target.value,
                      )
                    }
                  />
                </Grid>

                <Grid item xs={12}>
                  <div
                    style={{
                      color: themeStyle.primaryColor,
                      fontSize: "14px",
                      marginBottom: "10px",
                    }}
                  >
                    Address of Guardian
                  </div>
                  <TextField
                    label=" Address of Guardian"
                    fullWidth
                    multiline
                    rows={3}
                    value={formData.others.addressOfGuardian}
                    onChange={(e) =>
                      handleInputChange(
                        "others",
                        "addressOfGuardian",
                        e.target.value,
                      )
                    }
                  />
                </Grid>

                <Grid item xs={12}>
                  <div
                    style={{
                      color: themeStyle.primaryColor,
                      fontSize: "14px",
                      marginBottom: "10px",
                    }}
                  >
                    Other information
                  </div>
                  <TextField
                    label="Other information if any"
                    fullWidth
                    multiline
                    rows={3}
                    value={formData.others.otherInformation}
                    onChange={(e) =>
                      handleInputChange(
                        "others",
                        "otherInformation",
                        e.target.value,
                      )
                    }
                  />
                </Grid>
              </Grid>
              <br />
              <br />
              <Typography variant="h6" sx={{ mt: 4 }}>
                Documents Required
              </Typography>
              <br />
              <Grid container spacing={state.auth.isMobile ? 2 : 3}>
                <Grid item xs={12} sm={3}>
                  <label
                    style={{ width: "100%" }}
                    htmlFor="contained-button-file-birth"
                  >
                    <input
                      style={{ display: "none" }}
                      id="contained-button-file-birth"
                      type="file"
                      onChange={(e) => onFileChangeBirth(e)}
                    />
                    <ButtonBase
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyCntent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                        cursor: "pointer",
                      }}
                      component="div"
                    >
                      <div style={{ height: "50px" }}>Birth Certificate *</div>

                      {birth ? selectedFileBirth.name : ""}
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyCntent: "center",
                          alignItems: "center",
                          marginTop: "5px",
                          width: state.auth.isMobile ? "250px" : "10vw",
                          height: state.auth.isMobile ? "350px" : "13.5vw",
                          backgroundColor: birth ? "#fff" : "#eee",
                          border: birth
                            ? "5px solid" + themeStyle.primaryColor
                            : "2px solid grey",
                        }}
                      >
                        {birth ? (
                          <CheckIcon
                            style={{
                              marginTop: "50px",
                              fontSize: "140px",
                              color: themeStyle.primaryColor,
                            }}
                          />
                        ) : (
                          <AddIcon
                            style={{
                              marginTop: "50px",
                              fontSize: "140px",
                              color: themeStyle.primaryColor,
                            }}
                          />
                        )}
                      </div>
                    </ButtonBase>
                  </label>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <label
                    style={{ width: "100%" }}
                    htmlFor="contained-button-file-leaving"
                  >
                    <input
                      style={{ display: "none" }}
                      id="contained-button-file-leaving"
                      type="file"
                      onChange={(e) => onFileChangeLeaving(e)}
                    />
                    <ButtonBase
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyCntent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                        cursor: "pointer",
                      }}
                      component="div"
                    >
                      <div style={{ height: "50px" }}>
                        Transfer / Leaving Certificate
                      </div>
                      {leaving ? selectedFileLeaving.name : ""}
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyCntent: "center",
                          alignItems: "center",
                          marginTop: "5px",
                          width: state.auth.isMobile ? "250px" : "10vw",
                          height: state.auth.isMobile ? "350px" : "13.5vw",
                          backgroundColor: leaving ? "#fff" : "#eee",
                          border: leaving
                            ? "5px solid" + themeStyle.primaryColor
                            : "2px solid grey",
                        }}
                      >
                        {leaving ? (
                          <CheckIcon
                            style={{
                              marginTop: "50px",
                              fontSize: "140px",
                              color: themeStyle.primaryColor,
                            }}
                          />
                        ) : (
                          <AddIcon
                            style={{
                              marginTop: "50px",
                              fontSize: "140px",
                              color: themeStyle.primaryColor,
                            }}
                          />
                        )}
                      </div>
                    </ButtonBase>
                  </label>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <label
                    style={{ width: "100%" }}
                    htmlFor="contained-button-file-progress"
                  >
                    <input
                      style={{ display: "none" }}
                      id="contained-button-file-progress"
                      type="file"
                      onChange={(e) => onFileChangeProgress(e)}
                    />
                    <ButtonBase
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyCntent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                        cursor: "pointer",
                      }}
                      component="div"
                    >
                      <div style={{ height: "50px" }}>
                        Latest Progress Report
                      </div>
                      {progress ? selectedFileProgress.name : ""}
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyCntent: "center",
                          alignItems: "center",
                          marginTop: "5px",
                          width: state.auth.isMobile ? "250px" : "10vw",
                          height: state.auth.isMobile ? "350px" : "13.5vw",
                          backgroundColor: progress ? "#fff" : "#eee",
                          border: progress
                            ? "5px solid" + themeStyle.primaryColor
                            : "2px solid grey",
                        }}
                      >
                        {progress ? (
                          <CheckIcon
                            style={{
                              marginTop: "50px",
                              fontSize: "140px",
                              color: themeStyle.primaryColor,
                            }}
                          />
                        ) : (
                          <AddIcon
                            style={{
                              marginTop: "50px",
                              fontSize: "140px",
                              color: themeStyle.primaryColor,
                            }}
                          />
                        )}
                      </div>
                    </ButtonBase>
                  </label>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <label
                    style={{ width: "100%" }}
                    htmlFor="contained-button-file-aadhar"
                  >
                    <input
                      style={{ display: "none" }}
                      id="contained-button-file-aadhar"
                      type="file"
                      onChange={(e) => onFileChangeAadhar(e)}
                    />
                    <ButtonBase
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyCntent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                        cursor: "pointer",
                      }}
                      component="div"
                    >
                      <div style={{ height: "50px" }}>Aadhar Card Copy</div>
                      {aadhar ? selectedFileAadhar.name : ""}
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyCntent: "center",
                          alignItems: "center",
                          marginTop: "5px",
                          width: state.auth.isMobile ? "250px" : "10vw",
                          height: state.auth.isMobile ? "350px" : "13.5vw",
                          backgroundColor: aadhar ? "#fff" : "#eee",
                          border: aadhar
                            ? "5px solid" + themeStyle.primaryColor
                            : "2px solid grey",
                        }}
                      >
                        {aadhar ? (
                          <CheckIcon
                            style={{
                              marginTop: "50px",
                              fontSize: "140px",
                              color: themeStyle.primaryColor,
                            }}
                          />
                        ) : (
                          <AddIcon
                            style={{
                              marginTop: "50px",
                              fontSize: "140px",
                              color: themeStyle.primaryColor,
                            }}
                          />
                        )}
                      </div>
                    </ButtonBase>
                  </label>
                </Grid>
              </Grid>
              <br />
              <br />
              <Grid container spacing={state.auth.isMobile ? 2 : 3}>
                <Grid item xs={12} sm={3}>
                  <label
                    style={{ width: "100%" }}
                    htmlFor="contained-button-file-parent1"
                  >
                    <input
                      style={{ display: "none" }}
                      id="contained-button-file-parent1"
                      type="file"
                      onChange={(e) => onFileChangeParent1(e)}
                    />
                    <ButtonBase
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyCntent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                        cursor: "pointer",
                      }}
                      component="div"
                    >
                      <div style={{ height: "50px" }}>Parent 1 Degree *</div>
                      {parent1 ? selectedFileParent1.name : ""}
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyCntent: "center",
                          alignItems: "center",
                          marginTop: "5px",
                          width: state.auth.isMobile ? "250px" : "10vw",
                          height: state.auth.isMobile ? "350px" : "13.5vw",
                          backgroundColor: parent1 ? "#fff" : "#eee",
                          border: parent1
                            ? "5px solid" + themeStyle.primaryColor
                            : "2px solid grey",
                        }}
                      >
                        {parent1 ? (
                          <CheckIcon
                            style={{
                              marginTop: "50px",
                              fontSize: "140px",
                              color: themeStyle.primaryColor,
                            }}
                          />
                        ) : (
                          <AddIcon
                            style={{
                              marginTop: "50px",
                              fontSize: "140px",
                              color: themeStyle.primaryColor,
                            }}
                          />
                        )}
                      </div>
                    </ButtonBase>
                  </label>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <label
                    style={{ width: "100%" }}
                    htmlFor="contained-button-file-parent2"
                  >
                    <input
                      style={{ display: "none" }}
                      id="contained-button-file-parent2"
                      type="file"
                      onChange={(e) => onFileChangeParent2(e)}
                    />
                    <ButtonBase
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyCntent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                        cursor: "pointer",
                      }}
                      component="div"
                    >
                      <div style={{ height: "50px" }}>Parent 2 Degree</div>
                      {parent2 ? selectedFileParent2.name : ""}
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyCntent: "center",
                          alignItems: "center",
                          marginTop: "5px",
                          width: state.auth.isMobile ? "250px" : "10vw",
                          height: state.auth.isMobile ? "350px" : "13.5vw",
                          backgroundColor: parent2 ? "#fff" : "#eee",
                          border: parent2
                            ? "5px solid" + themeStyle.primaryColor
                            : "2px solid grey",
                        }}
                      >
                        {parent2 ? (
                          <CheckIcon
                            style={{
                              marginTop: "50px",
                              fontSize: "140px",
                              color: themeStyle.primaryColor,
                            }}
                          />
                        ) : (
                          <AddIcon
                            style={{
                              marginTop: "50px",
                              fontSize: "140px",
                              color: themeStyle.primaryColor,
                            }}
                          />
                        )}
                      </div>
                    </ButtonBase>
                  </label>
                </Grid>
                {formData.student.isCSI ? (
                  <Grid item xs={12} sm={3}>
                    <label
                      style={{ width: "100%" }}
                      htmlFor="contained-button-file-baptism"
                    >
                      <input
                        style={{ display: "none" }}
                        id="contained-button-file-baptism"
                        type="file"
                        onChange={(e) => onFileChangeBaptism(e)}
                      />
                      <ButtonBase
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyCntent: "center",
                          alignItems: "center",
                          flexDirection: "column",
                          cursor: "pointer",
                        }}
                        component="div"
                      >
                        <div style={{ height: "50px" }}>
                          Baptism Certificate (* if CSI)
                        </div>
                        {baptism ? selectedFileBaptism.name : ""}
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyCntent: "center",
                            alignItems: "center",
                            marginTop: "5px",
                            width: state.auth.isMobile ? "250px" : "10vw",
                            height: state.auth.isMobile ? "350px" : "13.5vw",
                            backgroundColor: baptism ? "#fff" : "#eee",
                            border: baptism
                              ? "5px solid" + themeStyle.primaryColor
                              : "2px solid grey",
                          }}
                        >
                          {baptism ? (
                            <CheckIcon
                              style={{
                                marginTop: "50px",
                                fontSize: "140px",
                                color: themeStyle.primaryColor,
                              }}
                            />
                          ) : (
                            <AddIcon
                              style={{
                                marginTop: "50px",
                                fontSize: "140px",
                                color: themeStyle.primaryColor,
                              }}
                            />
                          )}
                        </div>
                      </ButtonBase>
                    </label>
                  </Grid>
                ) : (
                  ""
                )}
                {formData.student.isCSI ? (
                  <Grid item xs={12} sm={3}>
                    <label
                      style={{ width: "100%" }}
                      htmlFor="contained-button-file-church"
                    >
                      <input
                        style={{ display: "none" }}
                        id="contained-button-file-church"
                        type="file"
                        onChange={(e) => onFileChangeChurch(e)}
                      />
                      <ButtonBase
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyCntent: "center",
                          alignItems: "center",
                          flexDirection: "column",
                          cursor: "pointer",
                        }}
                        component="div"
                      >
                        <div style={{ height: "50px" }}>
                          {" "}
                          Church Membership (* if CSI)
                        </div>
                        {church ? selectedFileChurch.name : ""}
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyCntent: "center",
                            alignItems: "center",
                            marginTop: "5px",
                            width: state.auth.isMobile ? "250px" : "10vw",
                            height: state.auth.isMobile ? "350px" : "13.5vw",
                            backgroundColor: church ? "#fff" : "#eee",
                            border: church
                              ? "5px solid" + themeStyle.primaryColor
                              : "2px solid grey",
                          }}
                        >
                          {church ? (
                            <CheckIcon
                              style={{
                                marginTop: "50px",
                                fontSize: "140px",
                                color: themeStyle.primaryColor,
                              }}
                            />
                          ) : (
                            <AddIcon
                              style={{
                                marginTop: "50px",
                                fontSize: "140px",
                                color: themeStyle.primaryColor,
                              }}
                            />
                          )}
                        </div>
                      </ButtonBase>
                    </label>
                  </Grid>
                ) : (
                  ""
                )}
              </Grid>
              <br />
              <Typography variant="h6" sx={{ mt: 4 }}>
                Criteria for admission
              </Typography>
              <br />
              <div style={{ textAlign: "left" }}>
                <p>
                  1. Age criteria: The child should be 4 years as on June 01,
                  2026. The minimum age should be 4 years and the maximum age
                  permissible shall be 5 years. Attested copies of the Birth
                  Certificate issued by the Corporation must bear the name of
                  the child.{" "}
                </p>
                <p>
                  2. CSI candidates must submit additional documents such as
                  Baptism Certificate and the parent's Church membership letter.
                  They shall be members of the KCD Church for a minimum period
                  of five years.
                </p>
                <p>
                  3. As proof of residence a photocopy of either the Voter ID,
                  Passport, Aadhaar Card or rental agreement must be submitted.
                </p>
                <p>
                  4. Attested copies of both the parents' highest educational
                  qualification is mandatory
                </p>
              </div>
              <br />
              <Typography variant="h6" sx={{ mt: 4 }}>
                Declaration
              </Typography>
              <br />
              <div style={{ textAlign: "left" }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={formData.declaration.accepted}
                      style={{
                        transform: "scale(1.5)",
                        color: themeStyle.primaryColor,
                      }}
                      onChange={(e) =>
                        handleInputChange(
                          "declaration",
                          "accepted",
                          e.target.checked,
                        )
                      }
                    />
                  }
                  label={
                    "I agree to comply with all the rules and regulations of the Institution as prescribed and to meet all financial obligations incurred by my child's attendance at " +
                    MAIN_TITLE
                  }
                />{" "}
                <br />
                <br />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={formData.declaration.accepted2}
                      style={{
                        transform: "scale(1.5)",
                        color: themeStyle.primaryColor,
                      }}
                      onChange={(e) =>
                        handleInputChange(
                          "declaration",
                          "accepted2",
                          e.target.checked,
                        )
                      }
                    />
                  }
                  label="I herewith declare that all the information furnished by me in this application is true to the best of my knowledge. I also herewith declare that i will not claim any refund of any of the payments under any circumstances"
                />
              </div>
              <br /> <br />
              <Box mt={3}>
                <Button
                  type="submit"
                  variant="contained"
                  sx={{
                    backgroundColor: themeStyle.primaryColor,
                    color: "white",
                    width: state.auth.isMobile ? "100%" : "300px",
                    fontWeight: "bold",
                  }}
                >
                  Make Payment of ₹500/-
                </Button>
              </Box>
            </Box>
          </div>
        </div>
      );
    }
  }
};

export default StudentRegistrationForm;
